import * as Yup from 'yup';

import { signupInfoOptions as defaultSignupInfoOptions } from '../../../defaultFilters';

export const useTalentNetworkSignupFilter = ({ setFilters }) => {
  const signupInfoOptions = defaultSignupInfoOptions;

  const formSchema = Yup.object().shape({
    hasSignupInfo: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ hasSignupInfo }) => {
    setFilters({ hasSignupInfo });
  };

  return {
    formSchema,
    onSubmit,
    signupInfoOptions,
  };
};
